$horrorgamelanding_app $mol_page
	title @ \Horror Game
	plugins /
		<= Theme $mol_theme_auto
	header /
		<= Logo $mol_image
			uri \horrorgamelanding/logo/logo.jpg
		<= Nav $mol_nav
			sub /
				<= Home $mol_link
					uri \#
					title \Home
				<= About $mol_link
					uri \#about
					title \About
				<= Contact $mol_link
					uri \#contact
					title \Contact
		<= Lights $mol_lights_toggle
		<= Scroll $mol_button_minor
			title \Scroll to Footer
			click? <=> scroll_to_footer? true
	body /
		<= Hero $mol_section
			title \Welcome to the Horror
			sub /
				<= Subtitle $mol_paragraph
					title \Experience the terror like never before
		<= Features $mol_list
			rows /
				<= Story $mol_card
					title \Immersive Story
					sub /
						<= Story_text $mol_paragraph
							title \Dive into a deep and terrifying narrative
				<= Graphics $mol_card
					title \Stunning Graphics
					sub /
						<= Graphics_text $mol_paragraph
							title \Next-gen visuals that will haunt your dreams
				<= Sound $mol_card
					title \Dynamic Sound
					sub /
						<= Sound_text $mol_paragraph
							title \3D audio that will make you look over your shoulder
		<= Subscribe $horrorgamelanding_subscribe
		
	footer /
